import { api } from "@/api/client";
import { IsoDrawing } from "@/types";

export function getDrawing(id: string) {
  return api.get<IsoDrawing>(`isometricdrawing/${id}`);
}
